export default {
    getLog: state => [...state.items].reverse()
}